import React, { PureComponent } from 'react';
import { IndexRedirect, Route } from 'react-router';
import { Row, Col, Panel } from 'react-bootstrap';
import App from './components/App';
import SignUpForm from './components/SignUpForm';
import LogInForm from './components/LogInForm';
import CaseEdit from './components/CaseEdit';
import Cases from './components/Cases';
import ClientEdit from './components/ClientEdit';
import IntakeForm from './components/IntakeForm';
import Clients from './components/Clients';
import SignDocument from './components/SignDocument';
import ResetPasswordForm from './components/common/ResetPasswordForm';
import { isAuthenticated } from '../client/token';
import Reports from './components/Reports';
import PayFee from './components/PayFee';
import AdminDashboard from './components/AdminDashboard';
import AdminErrors from './components/AdminErrors';


class WordAppComponent extends PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = { WordApp: null };
    }

    componentDidMount() {
        import('../WordAddIn/components/WordApp').then((mod) => {
            this.setState({ WordApp: mod.WordApp });
        });
    }

    render() {
        const { WordApp } = this.state;
        return WordApp ? <WordApp {...this.props} /> : null;
    }
}

class Invalid extends PureComponent {
    render() {
        return (<h5>Oops... this page no longer exists.</h5>);
    }
}

class Account extends PureComponent {
    render() {
        return (<SignUpForm {...this.props}/>);
    }
}

class CasesTab extends PureComponent {
    render() {
        return (<div {...this.props}/>);
    }
}

class PublicIntake extends PureComponent {
    render() {
        let props = {...this.props};
        props.publicIntake = true;
        return (<IntakeForm {...props}/>);
    }
}


class EditCase extends PureComponent {
    render() {
        return (<CaseEdit editType='editCase' {...this.props}/>);
    }
}

class NewCase extends PureComponent {
    render() {
        return (<CaseEdit editType='newCase' {...this.props}/>);
    }
}

class ClientsTab extends PureComponent {
    render() {
        return (<div {...this.props}/>);
    }
}

class AllClients extends PureComponent {
    render() {
        return (<Clients {...this.props}/>);
    }
}

class NewClient extends PureComponent {
    render() {
        return (<ClientEdit editType='new' {...this.props}/>);
    }
}

class EditClient extends PureComponent {
    render() {
        return (<ClientEdit editType='edit' {...this.props}/>);
    }
}

class SignUp extends PureComponent {
    render() {
        return (<SignUpForm {...this.props} />);
    }
}

class LogIn extends PureComponent {
    render() {
        return (<LogInForm {...this.props}/>);
    }
}

class ResetPassword extends PureComponent {
    render() {
        return (
            <Row>
                <Col md={3} xs={2}></Col>
                <Col md={6} xs={8}>
                    <Panel data-hj-whitelist bsStyle="primary" header="Reset Password">
                        <ResetPasswordForm redirectOnSuccess="/user/login"/>
                    </Panel>
                </Col>
            </Row>
        );
    }
}


const requireAuth = (nextState, replace) => {
    let authenticated = true;
    if (__CLIENT__) {
        authenticated = isAuthenticated();
    }

    if (!authenticated) {
        replace({
           pathname: '/user/login',
           state: { nextPathname: nextState.location && nextState.location.pathname }
        })
    }
};


const requireWordAuth = (nextState, replace) => {
    let authenticated = true;
    if (__CLIENT__) {
        authenticated = isAuthenticated();
    }

    if (!authenticated) {
        replace({
           pathname: '/word/user/login',
           state: { nextPathname: nextState.location && nextState.location.pathname }
        })
    }
};


const redirectToHomePage = (nextState, replace) => {
    replace({
       pathname: '/case/all',
       state: { nextPathname: nextState.location && nextState.location.pathname }
    });
};

const loggedInRedirect = (nextState, replace) => {
    let authenticated = false;
    if (__CLIENT__) {
        authenticated = isAuthenticated();
    }

    if (authenticated) {
        replace({
           pathname: '/case/all',
           state: { nextPathname: nextState.location && nextState.location.pathname }
        })
    }
};

const wordLoggedInRedirect = (nextState, replace) => {
    let authenticated = false;
    if (__CLIENT__) {
        authenticated = isAuthenticated();
    }

    if (authenticated) {
        replace({
           pathname: '/word/dashboard',
           state: { nextPathname: nextState.location && nextState.location.pathname }
        })
    }
};

const routes = (
    <div>
    <Route path="/intake/:intakeHash" component={PublicIntake} />
    <Route path="/intake/:intakeHash/:matterHash" component={PublicIntake} />
    <Route path="/signandpay/:hash" component={Invalid} />
    <Route path="/sign/:hash" component={SignDocument} />
    <Route path="/pay/:hash" component={PayFee} />
    <Route path="/word" component={WordAppComponent} />
    <Route path="/lead/signup" component={SignUp} />
    <Route name="app" path="/" component={App}>
        <IndexRedirect to="case/all" />
        <Route path="user/resetPassword" component={ResetPassword} />
        <Route path="user/signup" component={SignUp} onEnter={loggedInRedirect} />
        <Route path="user/login" component={LogIn} onEnter={loggedInRedirect} />
        <Route path="user/account" component={Account} onEnter={requireAuth} />
        <Route path="admin" component={AdminDashboard} onEnter={requireAuth} />
        <Route path="admin/errors" component={AdminErrors} onEnter={requireAuth} />
        <Route path="case" component={CasesTab} onEnter={requireAuth}>
            <Route path="all" component={Cases} onEnter={requireAuth} />
            <Route path="reports" component={Reports} onEnter={requireAuth} />
            <Route path="new" component={NewCase} onEnter={requireAuth} />
            <Route path="edit" component={EditCase} onEnter={requireAuth}>
                <Route path="intake/:id" component={EditCase} onEnter={requireAuth} />
                <Route path="task/:id" component={EditCase} onEnter={requireAuth} />
                <Route path="event/:id" component={EditCase} onEnter={requireAuth} />
                <Route path="docs/:id" component={EditCase} onEnter={requireAuth} />
                <Route path="payment/:id" component={EditCase} onEnter={requireAuth} />
                <Route path="notes/:id" component={EditCase} onEnter={requireAuth} />
            </Route>
        </Route>
        <Route path="client" component={ClientsTab} onEnter={requireAuth}>
            <Route path="all" component={Clients} onEnter={requireAuth} />
            <Route path="new" component={NewClient} onEnter={requireAuth} />
            <Route path="edit/:id" component={EditClient} onEnter={requireAuth} />
        </Route>
        <Route path="*" onEnter={redirectToHomePage} />
    </Route>
    </div>
);

export default routes;
